export default __webpack_public_path__ + "static/media/attention-icon.322b1990.svg";